const colors = {
  linkColor: '#3c8dbc',
  primary1Color: '#29174F',
  primary2Color: '#17214F',
  tableBorderColor: '#e0e0e0',
  // tableHeadingColor: '#2D3C9F',
  tableHelpBackgroundColor: '#6C7E9D',
  tableSettingsBackgroundColor: '#6C7E9D',
  tableHeadingColor: '#000',
  tableSearchInactiveColor: '#ddd',
  tableSearchActiveColor: '#000',
  tableSortInactiveColor: '#ddd',
  tableSortActiveColor: '#000',
  textColor: '#333',
  success: '#9BBB59', // #81C784
  textSuccess: '#1DBB33',
  successOnHover: 'rgba(155, 187, 89, 0.8)',
  successFaded: 'rgba(155, 187, 89, 0.5)',
  info: '#4F81BD', // #4FC3F7
  infoOnHover: 'rgba(79, 129, 189, 0.8)',
  infoFaded: 'rgba(79, 129, 189, 0.6)',
  danger: '#FF3232', // #FF5722
  dangerOnHover: 'rgba(255, 50, 50, 0.8)',
  dangerFaded: 'rgba(255, 50, 50, 0.5)',
  warning: '#FFC000', // #FFF176
  warningOnHover: 'rgba(255, 192, 0, 0.8)',
  warningFaded: 'rgba(255, 192, 0, 0.5)',
  orange: '#FF851B',
  snapshotErrorName: '#7a0000',
  snapshotErrorDsc: '#a76f70',
};

// Other colors https://mycolor.space/?hex=%23536584&sub=1
export const backgrounds = {
  aqua: '#3488a9', // '#00c0ef'
  green: '#008A60', // '#00a65a'
  maroon: '#845863', // '#d81b60'
};

export default colors;
